var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{style:({width:_vm.width+'px',height:_vm.height+'px'}),attrs:{"src":_vm.url}})}
var staticRenderFns = []

export { render, staticRenderFns }